import { configureBambiApiClient } from '@bambi/api-client';
import { TooltipProvider } from '@bambi/component-library/src/components/Tooltip/Tooltip';
import { Provider as ReduxProvider } from 'react-redux';

import { useDatadogLogger } from '../common/external/datadog/useDatadogLogger';
import { Routing } from './app.routes';
import { DelinquentBanner } from './banner/DelinquentBanner';
import { MissingHeadquartersBanner } from './banner/MissingHeadquartersBanner';
import { PricingMovedBanner } from './banner/PricingMovedBanner';
import { TimeDriftBanner } from './banner/TimeDriftBanner';
import store from 'src/app/store/store';
import { configureAmplify } from 'src/common/external/aws';
import { BAMBI_API_BASE_URL } from 'src/common/external/bambi-api/constants';
import { PaymentMethodCaptureProvider } from 'src/common/forms/PaymentMethodCaptureForm/PaymentMethodCaptureContext';
import { RequiresConfirmationModal } from 'src/common/modals/RequiresConfirmationModal/RequiresConfirmationModal';
import { ToastConfigProvider } from 'src/common/primitives/Toast';
import { authService } from 'src/features/auth/authService';
import { RequireAuth } from 'src/features/auth/requireAuth';
import ChatProvider from 'src/features/chat/ChatProvider';

configureAmplify();

// Wire the shared @bambi/api-client SDK to this app's auth + org
// selection. Single call at app load; the SDK's lazy baseQuery resolves
// these getters per request.
configureBambiApiClient({
  // Matches the legacy `bambiBaseQuery`: pass through whatever the env
  // var resolves to (REACT_APP_BAMBI_API_BASE_URL); `fetchBaseQuery`
  // tolerates empty/undefined and treats it as relative.
  baseUrl: BAMBI_API_BASE_URL ?? '',
  getAuthToken: authService.getAccessToken,
  getOrgId: () => store.getState().auth.currentOrganizationId,
});

function App() {
  useDatadogLogger();

  return (
    <div className="App">
      <ReduxProvider store={store}>
        <ToastConfigProvider>
          <TooltipProvider delayDuration={200}>
            <RequireAuth>
              <ChatProvider>
                <PaymentMethodCaptureProvider>
                  <DelinquentBanner />
                  <TimeDriftBanner />
                  <MissingHeadquartersBanner />
                  <PricingMovedBanner />
                  <Routing />
                  <RequiresConfirmationModal />
                </PaymentMethodCaptureProvider>
              </ChatProvider>
            </RequireAuth>
          </TooltipProvider>
        </ToastConfigProvider>
      </ReduxProvider>
    </div>
  );
}

export default App;
